import styled from '@emotion/styled'
import type { CmsProps } from '../../types/cms'

type BackgroundProps = CmsProps & {
  height?: string
  silver?: boolean
  bgColour?: string
  padding?: string
}

export const Background = styled.section<BackgroundProps>`
  position: relative;
  height: ${({ height }) => (height ? height : '100%')};
  background-color: ${({ silver, theme, bgColour }) =>
    silver ? theme.palette.silver.main : bgColour ? bgColour : '#fff'};
  padding: ${({ theme, padding }) => (padding ? padding : theme.spacing(8, 0))};
  width: 100%;
`

export const PlexusHeader = styled(Background)`
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url('/headerimg_homepage_plexus.jpg');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  h1,
  h2,
  p,
  a {
    color: #fff;
    text-align: center;
    display: block;
  }
  a {
    text-decoration: underline;
  }
  h1 {
    margin-bottom: 2rem;
  }
  .carousel {
    margin-top: 4rem;
    @media (min-width: 63.938rem) {
      margin-top: 6rem;
      display: flex;
      justify-content: space-between;
    }
  }
`
